<template>
  <input
    type="text"
    class="fts-form-control"
    :class="{ 'form-control--error': error }"
    :value="value"
    @blur="onBlur"
  />
</template>

<script>
import Cleave from './src/Cleave';

export default {
  props: {
    value: {
      default: null,
      validator: (value) =>
        value === null ||
        typeof value === "string" ||
        value instanceof String ||
        typeof value === "number"
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    error: Boolean
  },
  model: {
    prop: "value",
    event: "updateValue"
  },
  data: () => ({
    cleave: null
  }),
  methods: {
    onBlur(event) {
      this.$emit("blur");
    }
  },
  mounted() {
    if (this.cleave) return;

    this.cleave = new Cleave(this.$el, this.options);
    this.$el.oninput = (event) => {
      const value = event.target.value;
      this.$emit("updateValue", value);
      if (value !== this.value) {
        this.$emit("change", value);
      }
    };
  },
  beforeDestroy() {
    if (!this.cleave) return;

    this.cleave.destroy();
    this.cleave = null;
  },
};
</script>